import { useState } from 'react';

const useCheckAutoFill = () => {
  const [autoFilled, setAutoFilled] = useState<any>(false);

  const handleCheckAnimation = e => {
    if (e.animationName === 'mui-auto-fill') {
      setAutoFilled(true);
    } else if (e.animationName === 'mui-auto-fill-cancel') {
      setAutoFilled(false);
    }
  };

  return [autoFilled, handleCheckAnimation];
};

export default useCheckAutoFill;
